module.exports = __webpack_public_path__ + "static/protectiid-sso-73259b3c5042c5d4a94f637949e602df.webp";